import { 
	AuthService, 
	ProgressService 
} from 'phoenix/services';
const template = require('./login.template');

/**
 * @ngdoc directive
 * @name phoenix.directive:pxLogin
 * @module phoenix
 * @restrict E
 * @description
 *
 * `pxLogin` is a universal login component for logging into the Phoenix API
 *
 * @param {string=} title This should typically be the application's name.
 * If no title is supplied the control's header will not be displayed
 *
 * @param {element=} headerIcon Optional element that will be transcluded in the DOM
 * of the login component's header
 *
 * @usage
 *
 * <px-login title="ShareBase">
 *	<header-icon>
 *		<div class="icon-class-with-backgroundUrlImage"></div>
 *	</header-icon>
 * </px-login>
 *
 */
export function LoginDirective(
	pxProgressService:ProgressService
) {
	return {
		restrict: 'E',
		transclude: {
			'headerIcon': 'headerIcon'
		},
		controller: LoginController,
		controllerAs: 'vm',
		template,
		bindToController: true,
		scope: {
			title: '@',
			headerIcon: '@?headerIcon'
		},
		link: function (scope, element, attrs) {
			//hide the progress indicator
			pxProgressService.visible = false;
			pxProgressService.backdrop = false;
		}
	};
}

LoginDirective.$inject = [
	'pxProgressService'
];

function LoginController(
	$state, 
	pxAuthService:AuthService, 
	pxAuthInterceptor
) {
	let vm = this;

	// this needs to be initially set to false to reduce flicker when auto-logging in;
	// child states wil unhide the UI
	vm.visible = false;
	vm.state = $state;	
	vm.sharedObjects = {
		emailAddress: '',
		message: ''
	};

	// If user is authenticated navigate to the default route
	if (pxAuthService.isAuthenticated) {
		pxAuthInterceptor.redirectPostLogin();
	}
}

LoginController.$inject = [
	'$state',
	'pxAuthService',
	'pxAuthInterceptor'
];



// WEBPACK FOOTER //
// ./src/phoenix/components/login/login.component.ts